import { z } from 'zod';
import {
  allocationsForLsoSortByValues,
  allocationsForShipperSortByValues,
} from 'src/apis/lng-marketing/mappings';
import {
  formOptionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { commonAllocationsSchema } from 'src/pages/lng/allocations/overview/utils';
import { lsoOptionSchema } from 'src/pages/lng/components/lso-searchable-multi-select';

// For LSOs
export function getLngAllocationsForLsoPageParamsSchema() {
  return z.object({
    ...commonAllocationsSchema.shape,
    sortBy: z.enum(allocationsForLsoSortByValues).default('LNG_DEAL_ID'),
    offerName: z.string().nullable().default(null),
    shipperOrganisationId: z.preprocess(
      preprocessAsArray,
      z.array(formOptionSchema).default([])
    ),
    ...getPaginationSchema().shape,
  });
}

// For Shippers
export function getLngAllocationsForShipperPageParamsSchema() {
  return z.object({
    ...commonAllocationsSchema.shape,
    sortBy: z.enum(allocationsForShipperSortByValues).default('LNG_DEAL_ID'),
    lsoOrganisationId: z.preprocess(
      preprocessAsArray,
      z.array(lsoOptionSchema).default([])
    ),
    ...getPaginationSchema().shape,
  });
}
